var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurationLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.375 3.28125H13.9062C15.4596 3.28125 16.7188 4.54045 16.7188 6.09375V10.625C16.7188 12.1783 15.4596 13.4375 13.9062 13.4375H9.375C7.8217 13.4375 6.5625 12.1783 6.5625 10.625V6.09375C6.5625 4.54045 7.8217 3.28125 9.375 3.28125Z",
    stroke: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.875 13.5391V13.9062C11.875 15.4595 10.6158 16.7188 9.0625 16.7188H6.09375C4.54045 16.7188 3.28125 15.4595 3.28125 13.9062V10.9375C3.28125 9.3842 4.54045 8.125 6.09375 8.125H6.54688",
    stroke: "#898989",
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurationLight);
export default __webpack_public_path__ + "static/media/curation_light.5fd4076b3d8d1ef904a72231c7146e3a.svg";
export { ForwardRef as ReactComponent };